module.exports = __webpack_public_path__ + "static/media/high-five-bro.645db61a.svg";